import { isNotEmpty } from '~/utils';

const formatAddressQuestionToDraftAddress = ({
  countyStateOrProvince,
  addressLine,
  addressLine2,
  addressLine3,
  addressLine4,
  postcode,
  townOrCity,
}) => ({
  street1: addressLine,
  street2: addressLine2 || '',
  street3: addressLine3 || '',
  street4: addressLine4 || '',
  city: townOrCity,
  county: countyStateOrProvince,
  postcode: postcode.replace(/\s+/g, ' ').trim(),
});

const formatDraftAddressToAddressQuestion = ({
  street1,
  street2,
  street3,
  street4,
  city,
  county,
  postcode,
}) => ({
  countyStateOrProvince: county,
  addressLine: street1,
  addressLine2: street2,
  addressLine3: street3,
  addressLine4: street4,
  postcode,
  townOrCity: city,
});

export const isObjectHasValidData = (obj) => Object.values(obj).some((value) => isNotEmpty(value));

export const mergeReduxDrafts = (tokenDraft, currentDraft) =>
  Object.entries(tokenDraft).reduce((acc, [key, value]) => {
    if (value && typeof value === 'object') {
      if (key === 'partner') {
        // for partners selection are: null || object without empty fields
        // otherwise: empty values in object mean that selection was not done
        acc[key] = isObjectHasValidData(value) || value.id == null ? value : currentDraft[key];
      } else {
        acc[key] = isObjectHasValidData(value) ? value : currentDraft[key];
      }
    } else {
      acc[key] = value || currentDraft[key];
    }
    return acc;
  }, {});

export const appointmentDraftHelpers = {
  formatAddressQuestionToDraftAddress,
  formatDraftAddressToAddressQuestion,
  mergeReduxDrafts,
};
